import { render, staticRenderFns } from "./batchManagement.vue?vue&type=template&id=5c13dbd7&scoped=true"
import script from "./batchManagement.vue?vue&type=script&lang=js"
export * from "./batchManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13dbd7",
  null
  
)

export default component.exports